export class ObjectCreatedResponse<T> {
  id: T
  
  constructor(id: T) {
    this.id = id
  }
}